<template>
   <div class="crud-wrapper">
      <crud :form-component="PartnerForm"
            alwaysUpdate="managerId,companyId"
            :grid-columns="gridColumns" obj="brand">
      </crud>
   </div>
</template>

<script>
   import PageClass from '@consigmais-team/vue-common/layout/defaultPage/pageClass';

   import PartnerForm from './PartnerForm';

   export default PageClass.extend({
      name: 'Partners',

      data () {
         return {
            PartnerForm,

            gridColumns: [
               {
                  dataField: 'name',
                  caption: 'Nome',
                  minWidth: 150
               },
               {
                  dataField: 'maxPaQty',
                  caption: 'PAs',
                  dataType: 'number',
                  format: { type: 'fixedPoint', precision: 0 },
                  width: 90
               },
               {
                  dataField: 'managerName',
                  caption: 'Gestor',
                  minWidth: 120
               },
               {
                  dataField: 'phone',
                  caption: 'Fone',
                  minWidth: 120
               },
               {
                  dataField: 'whatsapp',
                  caption: 'WhatsApp',
                  minWidth: 120
               },
               {
                  dataField: 'city',
                  caption: 'Cidade'
               },
               {
                  dataField: 'state',
                  caption: 'Estado',
                  width: 90
               }
            ]

         };

      }

   });

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Partners.vue